import { lazy, Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';

const Screen = lazy(() =>
  import('../screens/MCP/MCPScreen').then(m => ({ default: m.MCPScreen })),
);

export const Route = createFileRoute('/mcp')({
  component: () => (
    <Suspense fallback={<div style={{ padding: 32, color: 'var(--lca-gray-500)', fontSize: 13 }}>Loading…</div>}>
      <Screen />
    </Suspense>
  ),
});
